module.exports = __webpack_public_path__ + "static/media/10.e055170c.jpg";